export default "__VITE_ASSET__Dx2z7H1Q__"